import type { DatabaseUpdateQueryResult } from '../../types/database';

// Why does this exist? It'll be easy later if we want to change the format of this; e.g. [input.queryResult, input]
export default function formatDatabaseUpdateQueryResult<T>(
  input: Awaited<DatabaseUpdateQueryResult<T>>,
): Awaited<DatabaseUpdateQueryResult<T>> {
  return input;
}
